<template>
    <div class="my_notes_box">
        <div v-if="notesData.length > 0">
            <pull2 :pull="pull" :page="page" @getList="getList">
                <div class="notes_item_box" v-for="(item, index) in notesData" :key="index">
                    <div class="user_info_box">
                        <!-- <img :src="require('@/common/images/header/test.jpg')" alt=""> -->
                        <img :src="!item.customeratturl || item.customeratturl === ' '  ? require('@/common/images/header/user.png') : item.customeratturl" alt="">
                        <div>
                            <span>{{item.customername}}</span>
                            <img @click="delNote(item, index)" :src="require('@/common/images/mmy/icon_del.png')" alt="">
                        </div>
                    </div>
                    <p class="notes_text">{{item.content}}</p>
                    <div class="date_div">
                        <p>{{item.datetime}}</p>
                        <!-- <p><img :src="require('@/common/images/other/like.png')" alt="">赞({{item.praisecount}})</p> -->
                    </div>
                </div>
            </Pull2>    
        </div>
        <div v-if="notesData.length === 0" class="no_data_box">
            <img :src="require('@/common/images/mobile/img-noData.png')" alt="">
            <p>当前课程暂无我的笔记</p>
        </div>
    </div>
</template>

<script>
import Pull2 from 'views/mobile/components/pull/pull2'
import { mapGetters, mapActions } from "vuex"
import {Toast, Dialog} from 'vant'
import {getCourseMyNotes, deleteMyCourseNotes} from 'api/api'
export default {
    name: 'myNotes',
    props: ['myNotesData'],
    data() {
        return {
            notesData: [],
            page: {
                page: 1,
                pagesize: 10,
                pageCount: 2,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            }
        }
    },
    mounted() {},
    methods: {
        // 获取我的笔记
        findMyNotes(val) {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid,
                page: val,
                pagesize: 10
            }
            getCourseMyNotes({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.notesData = data.data.notesinfo
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        findMyPostNotes() {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid,
                page: 1,
                pagesize: 1
            }
            getCourseMyNotes({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // this.notesData = data.data.notesinfo
                    var arry = data.data.notesinfo
                    var arry2 = this.notesData
                    arry = arry.concat(arry2)
                    this.notesData = arry
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        getList() {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid
            }
            getCourseMyNotes({
                data: Object.assign({}, params, this.page),
                success: data => {
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.notesData = data.data.notesinfo
                    } else {
                        this.notesData = this.notesData.concat(data.data.notesinfo)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 删除个人笔记
        delNote(val, i) {
            // console.log(val)
            Dialog.confirm({
                // title: '删除笔记',
                message: '确定删除当前笔记？'
            }).then(() => {
                // 确定删除
                this.setLoading(true)
                var params = {
                    noteid: val.noteid
                }
                deleteMyCourseNotes({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        if (data) {
                            this.notesData.splice(i, 1)
                            Toast('删除成功')
                        }
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                // 取消删除
            })
            
        },
        ...mapActions(["setLoading"])
    },
    filters: {},
    watch: {
        myNotesData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                // console.log(this.myNotesData)
                this.notesData = this.myNotesData
            })
        }
    },
    computed: {
        ...mapGetters(["loading"])
    },
    components: {
        Pull2
    }
};
</script>

<style lang="scss" type="text/scss"></style>